<template>
  <div class="wrapper" v-if="companyInfo">
    <div class="section-menu-bar">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-bar"
        mode="horizontal"
        @select="handleTopMenuSelect"
      >
        <el-menu-item index="2">采购品类</el-menu-item>
        <el-menu-item index="1">销售品类</el-menu-item>
      </el-menu>
    </div>
    <div>
        <PurchaseAndSaleTabItem :zq="companyInfo.zq" :taxNo="taxNo"
                              :companyType="activeIndex"></PurchaseAndSaleTabItem>
      
    </div>

  </div>
</template>

<script>
import "@/pages/Result/ThreeYearResult/global.styl";
import PurchaseAndSaleTabItem
  from "@/pages/Result/ThreeYearResult/financialAnalysis/purchaseAndSale/PurchaseAndSaleTabItem";
import {getCompanyInfo} from "@/api/threeYears";

export default {
  name: "PurchaseAndSaleTab",
  components: {
    PurchaseAndSaleTabItem,

  },
  props: {
    taxNo: String,
  },
  data() {
    return {
      activeIndex: "2",
      companyInfo: null
    };
  },
  async mounted() {
    await this.loadCompanyInfo()
  },
  methods: {
    async loadCompanyInfo() {
      const res = await getCompanyInfo({programId: this.$route.params.uuid})
      this.companyInfo = res.data
    },
    /**
     * 顶部菜单点击
     * @param {string} key
     * @param {array<string>}keyPath
     */
    handleTopMenuSelect(key, keyPath) {
      this.activeIndex = key;
    },

  }
}
</script>

<style lang="stylus" scoped>
.wrapper
  margin-top 40px
  position relative

  .section-menu-bar
    border-bottom 1px solid #eee;


</style>
